import React from 'react';
import { Field } from 'redux-form';
import { Col } from 'react-bootstrap';
import {
  renderEmailField,
  renderPhoneField,
  renderSelectField,
  phoneParser,
  phoneFormatter,
} from '../../../utils/redux-form-helper';

const DeleteButton = ({ onClick, disabled }) => (
  <div className="row-remove-btn">
    <a
      onClick={disabled ? undefined : onClick}
      style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
    >
      <i className="et-trash" />
    </a>
  </div>
);

const DynamicContactField = ({
  fieldName,
  index,
  type, // 'email' or 'phone'
  typeOptions,
  onRemove,
  disabled,
  placeholder,
  validate,
  isPrimary,
  canDelete,
  showLabels,
  layout, // 'horizontal' or 'vertical'
  colSizes,
  label,
}) => {
  const isEmail = type === 'email';
  const inputComponent = isEmail ? renderEmailField : renderPhoneField;
  const inputProps = isEmail
    ? {
        maxLength: '70',
      }
    : {
        parse: phoneParser,
        format: phoneFormatter,
      };

  const defaultColSizes = {
    input: layout === 'horizontal' ? 5 : 12,
    type: layout === 'horizontal' ? 5 : 12,
    delete: layout === 'horizontal' ? 2 : 12,
  };

  const cols = { ...defaultColSizes, ...colSizes };

  if (layout === 'horizontal') {
    return (
      <>
        <Col xs={6} sm={cols.input}>
          <Field
            name={`${fieldName}.${
              type === 'email' ? 'emailAddress' : 'phoneNumber'
            }`}
            component={inputComponent}
            placeholder={placeholder}
            disabled={disabled}
            validate={validate}
            label={showLabels ? label : undefined}
            showLabel={showLabels}
            {...inputProps}
          />
        </Col>
        <Col xs={6} sm={cols.type}>
          <Field
            name={`${fieldName}.${
              type === 'email' ? 'emailType' : 'phoneType'
            }`}
            component={renderSelectField}
            options={typeOptions}
            disabled={disabled}
          />
        </Col>
        {canDelete && (
          <Col xs={6} sm={cols.delete}>
            <DeleteButton onClick={() => onRemove(index)} disabled={disabled} />
          </Col>
        )}
      </>
    );
  }

  return (
    <div style={{ marginBottom: '10px' }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '5px' }}>
        <div style={{ flex: '2' }}>
          <Field
            name={`${fieldName}.${
              type === 'email' ? 'emailAddress' : 'phoneNumber'
            }`}
            component={inputComponent}
            placeholder={placeholder}
            disabled={disabled}
            validate={validate}
            label={showLabels ? label : undefined}
            showLabel={showLabels}
            {...inputProps}
          />
        </div>
        <div style={{ flex: '1' }}>
          <Field
            name={`${fieldName}.${
              type === 'email' ? 'emailType' : 'phoneType'
            }`}
            component={renderSelectField}
            options={typeOptions}
            disabled={disabled}
            label={showLabels ? 'Type' : undefined}
            showLabel={showLabels}
          />
        </div>
        <div
          style={{
            flex: 1,
            maxWidth: '25px',
            display: 'flex',
            alignItems: 'center',
            height: '34px',
            marginTop: showLabels ? '21px' : '0px',
          }}
        >
          {canDelete && (
            <DeleteButton onClick={() => onRemove(index)} disabled={disabled} />
          )}
        </div>
      </div>
    </div>
  );
};

export default DynamicContactField;
